export type GuideSection = {
  heading: string;
  paragraphs?: string[];
  bullets?: string[];
};

export type Guide = {
  slug: string;
  title: string;
  seoTitle: string;
  description: string;
  readTime: string;
  intro: string;
  sections: GuideSection[];
  faq: Array<{ question: string; answer: string }>;
};

export const guides: Guide[] = [
  {
    slug: "onde-assistir-doramas-dublados",
    title: "Onde assistir doramas dublados em português",
    seoTitle: "Onde assistir doramas dublados em português (2026) | DoramaFlix",
    description: "Guia atualizado de onde assistir doramas dublados em português, com pagamento único e sem assinatura mensal.",
    readTime: "5 min de leitura",
    intro: "Procurar dorama dublado em português ainda é uma dor de cabeça: a maior parte dos catálogos grandes só oferece legenda. Neste guia explicamos onde encontrar novelinhas asiáticas dubladas, o que muda entre dublado e legendado e como assistir sem assinatura mensal.",
    sections: [
      {
        heading: "Dublado ou legendado: qual escolher?",
        paragraphs: [
          "O áudio dublado é a escolha de quem quer assistir sem prender os olhos na tela — cozinhando ou enquanto faz outra coisa. Já a legenda preserva a interpretação original dos atores e costuma chegar mais rápido depois da estreia.",
          "No DoramaFlix, nos títulos com dublagem, é possível trocar entre áudio dublado e legendado dentro do player.",
        ],
        bullets: ["Dublado: melhor para maratonar sem atenção total à tela.", "Legendado: melhor para acompanhar a atuação original.", "Troca de idioma no player, sem sair da página."],
      },
      {
        heading: "Dá para assistir dorama dublado de graça?",
        paragraphs: [
          "Existem sites que prometem catálogo gratuito, mas frequentemente entregam anúncios agressivos, links quebrados e qualidade baixa.",
          "Na versão oficial, o trailer e o primeiro episódio ficam disponíveis para você conferir a qualidade antes de decidir pelo desbloqueio.",
        ],
      },
      {
        heading: "Quanto custa assistir no DoramaFlix",
        paragraphs: ["Uma novela completa custa a partir de R$ 4,99 em pagamento único. O Passe Vitalício de R$ 27 libera o catálogo inteiro e os lançamentos futuros, sem renovação automática."],
      },
    ],
    faq: [
      { question: "Onde assistir doramas dublados em português?", answer: "No DoramaFlix você encontra novelinhas asiáticas com áudio dublado em português, trailer e primeiro episódio para conhecer antes do desbloqueio." },
      { question: "Precisa de assinatura mensal?", answer: "Não. O modelo é de pagamento único por novela ou pelo Passe Vitalício." },
      { question: "Posso trocar entre dublado e legendado?", answer: "Sim, nos títulos que oferecem as duas versões." },
    ],
  },
  {
    slug: "melhores-doramas-romanticos",
    title: "Melhores doramas românticos para assistir online",
    seoTitle: "Melhores doramas românticos para assistir online (2026) | DoramaFlix",
    description: "Seleção de doramas românticos dublados e legendados para assistir online.",
    readTime: "4 min de leitura",
    intro: "Romance é o gênero que mais transforma curioso em fã de dorama. Reunimos histórias românticas do catálogo com acesso imediato depois do desbloqueio.",
    sections: [
      { heading: "Por que os doramas românticos viciam tanto", paragraphs: ["A construção lenta do casal, o cuidado com os detalhes e a trilha sonora fazem o romance asiático funcionar de um jeito diferente das novelas tradicionais."] },
      {
        heading: "Como escolher por onde começar",
        paragraphs: ["Se é sua primeira vez, comece por histórias curtas e fechadas. Depois vale partir para romances de época e dramas mais longos."],
        bullets: ["Primeira vez: prefira novelas completas e curtas.", "Quer emoção: procure os dramas com nota alta.", "Quer leveza: comédia romântica é o caminho."],
      },
      { heading: "Doramas românticos no catálogo", paragraphs: ["No catálogo você encontra títulos como Respirar, Flechaço Entre Luz e Escuridão, Refúgio Perigoso e Superando Meu Guarda-Costas."] },
    ],
    faq: [
      { question: "Qual o melhor dorama romântico para começar?", answer: "Comece por uma história completa e curta. Confira a sinopse e a prévia antes de escolher." },
      { question: "Os doramas românticos têm dublagem?", answer: "Boa parte do catálogo tem áudio dublado em português e opção legendada." },
    ],
  },
  {
    slug: "como-assistir-doramas-online-sem-assinatura",
    title: "Como assistir doramas online sem assinatura mensal",
    seoTitle: "Como assistir doramas online sem assinatura mensal | DoramaFlix",
    description: "Passo a passo para assistir doramas com pagamento único, sem mensalidade e sem renovação automática.",
    readTime: "3 min de leitura",
    intro: "Nem todo mundo quer mais uma mensalidade no cartão. Este guia mostra como assistir novelinhas asiáticas pagando uma única vez, sem fidelidade e sem renovação automática.",
    sections: [
      {
        heading: "Passo a passo",
        paragraphs: ["O processo foi desenhado para levar menos de um minuto, do primeiro clique até o acesso à novela completa."],
        bullets: ["Escolha a novelinha e confira a prévia.", "Crie sua conta com e-mail e senha.", "Escolha PIX ou cartão.", "Depois da confirmação, o acesso fica salvo na sua conta."],
      },
      { heading: "Pagamento único x assinatura", paragraphs: ["Na assinatura você paga todo mês. No pagamento único, paga uma vez pelo conteúdo escolhido. Para quem pretende assistir a vários títulos, existe o Passe Vitalício."] },
      { heading: "Suporte quando algo dá errado", paragraphs: ["O suporte oficial atende pelo Telegram para dúvidas sobre pagamento, acesso e reprodução."] },
    ],
    faq: [
      { question: "Tem cobrança recorrente?", answer: "Não. Os pagamentos oferecidos são únicos e não possuem renovação automática." },
      { question: "Quanto demora para liberar depois do PIX?", answer: "A liberação normalmente acontece após a confirmação do pagamento pelo provedor." },
      { question: "Preciso confirmar e-mail?", answer: "Não. A conta é criada e acessada imediatamente com e-mail e senha, sem código de confirmação." },
    ],
  },
  {
    slug: "novelas-turcas-online-dubladas",
    title: "Novelas turcas online dubladas",
    seoTitle: "Novelas turcas online dubladas: onde assistir | DoramaFlix",
    description: "Onde assistir novelas turcas dubladas em português com pagamento único.",
    readTime: "3 min de leitura",
    intro: "As novelas turcas conquistaram o público brasileiro com dramas familiares intensos e produções caprichadas. Veja onde assistir os títulos turcos dublados e como funciona o acesso.",
    sections: [
      { heading: "Por que fazem tanto sucesso no Brasil", paragraphs: ["O ritmo lembra o das novelas brasileiras: conflitos familiares, vingança, reviravoltas e romance, com produção cinematográfica e cenários de Istambul."] },
      { heading: "Como assistir", paragraphs: ["Escolha o título, conheça a prévia e desbloqueie a novela completa individualmente ou pelo Passe Vitalício."] },
      { heading: "Novelas turcas no catálogo", paragraphs: ["Sua Doce Bela e O Homem que Estava ao Teu Lado estão entre os títulos turcos disponíveis atualmente."] },
    ],
    faq: [
      { question: "As novelas turcas estão dubladas em português?", answer: "Os títulos identificados como dublados oferecem áudio em português no player." },
      { question: "Preciso pagar por episódio?", answer: "Não. O desbloqueio é feito para o título completo." },
    ],
  },
];

export const guideBySlug = new Map(guides.map((guide) => [guide.slug, guide]));
